import React from 'react';

import { PaymentInvoice } from '../../components/Payment';

const PaymentInvoiceView: React.FC = () => {
  return <PaymentInvoice />;
};

export default PaymentInvoiceView;


